import { useState, useEffect } from 'react';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
const SortingModalCreditsHistoryMain = (props) => {
  const { isMobile } = useMobileSettings();
  const [component, setComponent] = useState(null);

  useEffect(() => {
    const loadComponent = async () => {
      if (isMobile) {
        const module = await import(
          '../MobileComponents/SortingModalCreditsHistoryMob'
        );
        setComponent(() => module.default);
      } else {
        const module = await import(
          '../WebComponents/SortingModalCreditsHistoryWeb'
        );
        setComponent(() => module.default);
      }
    };

    loadComponent();
  }, [isMobile]);

  const LoadedComponent = component;
  return component ? <LoadedComponent {...props} /> : <></>;
};

export default SortingModalCreditsHistoryMain;
